import { Component, Input } from '@angular/core';
import { Events } from 'ionic-angular/util/events';

/**
 * Generated class for the DrawerItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'drawer-list',
  templateUrl: 'drawer-list.html'
})
export class DrawerListComponent {

  @Input() pages: Array<{ title: string, component?: any, showSubmenu?: boolean, submenu?: Array<{ title: string, component: any, }> }>;

  @Input() pageSelected: any

  constructor(public events: Events) {

  }

  itemSelected(page: any) {

    if (page.component != undefined) {
      this.pageSelected = page;
      this.events.publish("drawer:item_selected", page)

    } else if (page.submenu != undefined) {

      if (page.showSubmenu == undefined || page.showSubmenu == false)
        page.showSubmenu = true
      else {
        if (page.submenu.find((item) => { return item == this.pageSelected }) == undefined)
          page.showSubmenu = false
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/components/drawer-list/drawer-list.ts